import { BOMTab, PNIDTab } from "./BOMTab";
import ECSTab from "./ECS";
// import MCSSCurve from "./SCurve";
// import PlantTasksWrapper from "../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
import Schedule4D from "./Schedule4D";

export const getMCSTabs = (mrqList = []) => [
  {
    label: "Major Equipments",
    moduleKey: "mcs-equipment-list",
    panel: <ECSTab />,
  },
  {
    label: "Valves & Instrumentation",
    moduleKey: "mcs-valves-instrumentation",
    panel: <PNIDTab />,
  },
  {
    label: "Bulk Materials",
    moduleKey: "mcs-bulk-materials",
    panel: <BOMTab />,
  },
  {
    label: "4D Schedule",
    moduleKey: "schedule",
    // panel: <PlantTasksWrapper type={"procurement"} mrq={mrqList} />,
    panel: <Schedule4D />,
  },
];
